


























































































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import { Datetime } from 'vue-datetime';
import { IPaymentMethod } from '@/interfaces';
import { dispatchGetAvailablePaymentMethods } from '@/store/main/actions';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
    Datetime,
  },
})
export default class ManualDonationModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: true, default: null}) readonly public leadId: number | null;
  public formError = false;
  public type: number = 2;
  public users: number[] = [];
  public category: number | null = null;
  public paymentMethod: number | null = null;
  public amount: number = 0;
  public createdAt: any = '';
  // public paySystem: string = 'A';
  public attachment: any = null;
  public loadingState = {
    submit: false,
  };
  public paymentMethods: IPaymentMethod[] = [];
  public pageElements: any = [];

  public mounted() {
    if (this.leadId) {
      this.type = 1;
    }
    this.handleChangeType(null);
  }

  public validateForm() {
    console.log('type', this.type);
    if (this.type === 2) {
      if (this.pageElements.length === 0) {
        // @ts-ignore
        this.showToast(this, this.$t('Add at least one contact'), 'error');
        return false;
      }
      let itemsDict: any = {};
      for (let i in this.pageElements) {
        if (!this.pageElements[i].user || !this.pageElements[i].category || !this.pageElements[i].amount) {
          this.formError = true;
          // @ts-ignore
          this.showToast(this, this.$t('Please, fill all fields'), 'error');
          return false;
        }
        if (this.pageElements[i].user in itemsDict) {
          if (itemsDict[this.pageElements[i].user].includes(this.pageElements[i].category)) {
            // @ts-ignore
            this.showToast(this, this.$t('Contact must have only one particular category at a time'), 'error');
            return false;
          }
          itemsDict[this.pageElements[i].user].push(this.pageElements[i].category);
        } else {
          itemsDict[this.pageElements[i].user] = [this.pageElements[i].category];
        }
      }
      console.log('itemsDict', itemsDict);
    }

    if ((this.type !== 2 && (!this.amount || !this.category)) || !this.createdAt) {
      this.formError = true;
      // @ts-ignore
      this.showToast(this, this.$t('Please, fill all fields'), 'error');
      return false;
    } else if (new Date(this.createdAt) > new Date()) {
      this.formError = true;
      // @ts-ignore
      this.showToast(this, this.$t('Payment date and time is invalid'), 'error');
      return false;
    } else {
      this.formError = false;
      return true;
    }
  }

  public resetForm() {
    this.type = 1;
    this.amount = 0;
    this.attachment = null;
    this.category = null;
    this.paymentMethod = null;
    this.createdAt = '';
    this.pageElements = [];
    this.$emit('close-modal');
  }

  public generatePayload(element: any) {
    const formData = new FormData();
    if (this.leadId) {
      // @ts-ignore
      formData.append('type', 1);
    } else {
      // @ts-ignore
      formData.append('type', this.type);
    }
    // @ts-ignore
    formData.append('user', element.user ? element.user : '');
    // @ts-ignore
    formData.append('amount', element.amount);
    if (this.attachment) {
      formData.append('attachment', this.attachment);
    }
    // @ts-ignore
    formData.append('category', element.category);
    if (element.paymentMethod) {
    // @ts-ignore
    formData.append('payment_method', element.paymentMethod);
    }
    formData.append('created_at', this.createdAt);
    return formData;
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      try {
        if (this.type === 2) {
          for (let i in this.pageElements) {
            const payload = this.generatePayload(this.pageElements[i]);
            await api.submitManualDonation(
              this.$store.getters.token, payload,
            );
          }
        } else {
          const payload = this.generatePayload({
            user: this.leadId ? this.leadId : null,
            amount: this.amount,
            category: this.category,
            paymentMethod: this.paymentMethod,
          });
          await api.submitManualDonation(
            this.$store.getters.token, payload,
          );
        }
        // @ts-ignore
        this.showToast(this, this.$t('Donation created'));
        this.$emit('created-event');
        this.resetForm();
      } catch (error) {
        // @ts-ignore
        if (error.response.data) {
          let errorMsg = '';
          // @ts-ignore
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public handleChangeType(event) {
    if (this.type === 2 && this.pageElements.length === 0) {
      this.handleAddPageElement();
    }
  }

  public handleChangeCategory(value) {
    this.category = value;
    this.handleUpdatePaymentMethods();
  }

  public async handleChangeElementCategory(element, value) {
    element.category = value;
    element.paymentMethod = null;
    let paymentMethods: any = []
    if (element.category) {
      paymentMethods = await dispatchGetAvailablePaymentMethods(
          this.$store, {category: element.category},
      );
    }
    const payMethods: any = [];
    if (paymentMethods) {
      for (const [key, value] of Object.entries(paymentMethods)) {
        payMethods.push({
          // @ts-ignore
          value: value.id, text: value.title,
        });
      }
    }
    element.paymentMethods = payMethods;
    let newList: any = [];
    for (const [key, value] of Object.entries(this.pageElements)) {
      // @ts-ignore
      if (value.id == element.id) {
        // @ts-ignore
        value.category = element.category;
        // @ts-ignore
        value.paymentMethod = null;
        // @ts-ignore
        value.paymentMethods = payMethods;
      }
      newList.push(value);
    }
    this.pageElements = newList;
  }

  public handleChangeElementUser(element, value) {
    element.user = value;
  }

  public handleChangeUsers(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.users = newList;
  }

  public async handleUpdatePaymentMethods() {
    this.paymentMethod = null;
    if (this.category) {
      this.paymentMethods = await dispatchGetAvailablePaymentMethods(
          this.$store, {category: this.category},
      );
    }
  }

  public handleAddPageElement() {
    let newelement: any = {
      id: `new-${Math.floor(Math.random() * (100 - 0 + 1) + 0)}`,
      user: null,
      amount: '',
      category: null,
      paymentMethod: null,
      paymentMethods: [],
    };
    this.pageElements.push(newelement);
  }

  public async handleDeleteElement(elementId) {
    // @ts-ignore
    this.$swal({
      // @ts-ignore
      title: this.$t('Remove element?'),
      // icon: 'warning',
      buttons: {
        cancel: {
          // @ts-ignore
          text: this.$t('Cancel'),
          value: false,
          visible: true,
          className: 'btn btn-secondary',
          closeModal: true,
        },
        confirm: {
          // @ts-ignore
          text: this.$t('Confirm'),
          value: true,
          visible: true,
          className: 'btn btn-primary',
          closeModal: true,
        },
      },
    }).then(async (value) => {
      if (value) {
        let newList: any = [];
        for (const [key, value] of Object.entries(this.pageElements)) {
          // @ts-ignore
          if (value.id !== elementId) {
            newList.push(value);
          }
        }
        this.pageElements = newList;
      }
    });
  }

  get payMethods() {
    const payMethods: any = [];
    if (this.paymentMethods) {
      for (const [key, value] of Object.entries(this.paymentMethods)) {
        payMethods.push({
          value: value.id, text: value.title,
        });
      }
    }
    return payMethods;
  }

  get donationTypes() {
    return [
      {
        value: 2,
        text: this.$t('Several contacts'),
      },
      {
        value: 3,
        text: this.$t('General donation'),
      },
    ];
  }

}
